import {
    resolveColorContext,
    type ContextSelection,
} from '@quipex/shared/utils';
import type { BuildingInfoSource } from './models';

export interface BuildingInfoSourcePresentation {
    readonly context: ContextSelection;
    readonly backgroundColor: string;
    readonly source: BuildingInfoSource;
    readonly textColor: string;
}

export function selectedBuildingInfoSourcePresentation(
    sources: readonly BuildingInfoSource[]
): BuildingInfoSourcePresentation | null {
    const source = sources.find((candidate) => candidate.selected);
    const context = source ? buildingInfoSourceSelection(source) : null;

    return source && context
        ? {
              context,
              backgroundColor: `var(${resolveColorContext(context.family, context.tone).surface.variable})`,
              source,
              textColor: `var(${resolveColorContext(source.context).decorative.variable})`,
          }
        : null;
}

function buildingInfoSourceSelection(
    source: BuildingInfoSource
): ContextSelection {
    return { family: source.context, tone: 'muted' };
}
